import React, { useContext } from 'react';
import { SignupContext } from './SignupContext';
import { phoneFormat } from '../../../api/utils/format/numbers';
import TextWinds from '../../../components/common/TextWinds';
import { useAppDispatch } from '../../../store/hook';
import { useNavigate } from 'react-router-dom';
import ErrorInput from '../../../components/common/ErrorInput';
import { openConfirm } from '../../../store/features/modalSlice';
import { check14UnderAge } from '../../../api/utils/util-func';
import GuadianForm from './GuadianForm';
import { Input } from 'antd';
import HFbutton from '../../../components/button/HFbutton';
import FormRow from '../../../components/common/input/FormRow';
import {
  SIGNUP_MESSAGES,
  SIGNUP_LABELS,
  SIGNUP_BUTTONS,
  SIGNUP_PLACEHOLDERS,
} from './constants';
import { useSignupForm } from './hooks/useSignupForm';
import { useUidDuplicateCheck } from './hooks/useUidDuplicateCheck';
import { useSignupSubmit } from './hooks/useSignupSubmit';
import {
  birthdayRules,
  emailRules,
  nameRules,
  passwordRules,
  uidRules,
} from '../../../constants/validation';
const InfoForm = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { phone } = useContext(SignupContext);

  // Custom hooks
  const { control, handleSubmit, watch, errors, password, uid, clearErrors } =
    useSignupForm();
  const { checkDuplicate, getIdCheck } = useUidDuplicateCheck(
    uid,
    control,
    clearErrors,
  );
  const { isLoading, onSubmit } = useSignupSubmit(checkDuplicate, control);

  const handleCancel = () => {
    dispatch(
      openConfirm({
        message: SIGNUP_MESSAGES.CANCEL_CONFIRM,
        onConfirm: () => {
          navigate('/signin');
        },
        cancelText: SIGNUP_BUTTONS.CONTINUE_SIGNUP,
        confirmText: SIGNUP_BUTTONS.CANCEL_SIGNUP,
      }),
    );
  };

  return (
    <form className="flex flex-col gap-4">
      <section>
        <TextWinds type="title_h2">{SIGNUP_LABELS.TITLE}</TextWinds>
      </section>
      <section className="flex flex-col gap-2">
        <TextWinds type="caption1" children={SIGNUP_LABELS.PHONE} />
        <Input
          size="large"
          placeholder={SIGNUP_PLACEHOLDERS.PHONE}
          value={phoneFormat(phone)}
          disabled
        />

        <FormRow
          type="text-button"
          name="uid"
          className="p-3"
          rules={uidRules({
            required: SIGNUP_MESSAGES.UID_REQUIRED,
            validate: {
              duplicateChecked: () =>
                checkDuplicate || SIGNUP_MESSAGES.DUPLICATE_CHECK_REQUIRED,
            },
          })}
          placeholder={SIGNUP_PLACEHOLDERS.UID}
          control={control}
          error={!!errors.uid}
          textButtonProp={{
            text: SIGNUP_BUTTONS.DUPLICATE_CHECK,
            action: getIdCheck,
          }}
        />
        {errors.uid && <ErrorInput text={errors.uid.message} />}

        <FormRow
          type="text"
          name="email"
          rules={emailRules({ required: SIGNUP_MESSAGES.EMAIL_REQUIRED })}
          placeholder={SIGNUP_PLACEHOLDERS.EMAIL}
          control={control}
          error={!!errors.email}
        />
        {errors.email && <ErrorInput text={errors.email.message} />}

        <FormRow
          type="password"
          name="password"
          rules={passwordRules({ required: SIGNUP_MESSAGES.PASSWORD_REQUIRED })}
          placeholder={SIGNUP_PLACEHOLDERS.PASSWORD}
          control={control}
          error={!!errors.password}
        />
        {errors.password && <ErrorInput text={errors.password.message} />}

        <FormRow
          type="password"
          name="password2"
          rules={{
            required: SIGNUP_MESSAGES.PASSWORD_CONFIRM_REQUIRED,
            validate: (value) =>
              value === password || SIGNUP_MESSAGES.PASSWORD_NOT_MATCH,
          }}
          placeholder={SIGNUP_PLACEHOLDERS.PASSWORD_CONFIRM}
          control={control}
          error={!!errors.password2}
        />
        {errors.password2 && <ErrorInput text={errors.password2.message} />}

        <FormRow
          type="text"
          name="name"
          rules={nameRules({ required: true })}
          placeholder={SIGNUP_PLACEHOLDERS.NAME}
          control={control}
          error={!!errors.name}
        />
        {errors.name && <ErrorInput text={errors.name.message} />}

        <FormRow
          name={'birthday'}
          type={'birthday'}
          rules={birthdayRules({ required: SIGNUP_MESSAGES.BIRTHDAY_REQUIRED })}
          control={control}
          error={!!errors.birthday}
        />
        {errors.birthday && <ErrorInput text={errors.birthday.message} />}

        <FormRow
          name="gender"
          type={'gender'}
          control={control}
          rules={{ required: SIGNUP_MESSAGES.GENDER_REQUIRED }}
          error={!!errors.gender}
        />
        {errors.gender && <ErrorInput text={errors.gender.message} />}
      </section>
      {check14UnderAge(watch('birthday')) && (
        <section>
          <GuadianForm control={control} errors={errors} />
        </section>
      )}
      <section className="flex flex-col gap-2">
        <HFbutton onClick={handleSubmit(onSubmit)} disabled={isLoading}>
          {isLoading
            ? SIGNUP_BUTTONS.SIGNUP_IN_PROGRESS
            : SIGNUP_BUTTONS.SIGNUP}
        </HFbutton>
        <HFbutton type="primary-outlined" onClick={handleCancel}>
          {SIGNUP_BUTTONS.CANCEL}
        </HFbutton>
      </section>
    </form>
  );
};

export default InfoForm;
